import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import agent from "../../../app/api/agent";

export const useCodeValidation = () => {
  const { t } = useTranslation();

  const validateCodeUniqueness = useCallback(
    async (code: string): Promise<string | true> => {
      if (!code || code.trim() === "") {
        return true;
      }

      try {
        const isUnique = await agent.Companies.checkCodeUniqueness(code.trim());
        if (!isUnique) {
          return t("errors.company_code_not_unique");
        }
        return true;
      } catch (error) {
        // If API call fails, we'll allow the field to pass validation
        // to avoid blocking the user due to network issues
        return true;
      }
    },
    [t]
  );

  return { validateCodeUniqueness };
};
